import {
  LAYOUT_CHATDRAWER_CLOSE,
  LAYOUT_CHATDRAWER_OPEN,
  LAYOUT_INBOX_CLOSE,
  LAYOUT_INBOX_OPEN,
  LAYOUT_LEFTBAR_CLOSE,
  LAYOUT_LEFTBAR_MODULE_CLOSE,
  LAYOUT_LEFTBAR_MODULE_OPEN,
  LAYOUT_LEFTBAR_OPEN,
  LAYOUT_SNACKBAR_MESSAGE_HIDE,
  LAYOUT_SNACKBAR_MESSAGE_SHOW,
} from "../actions/layout";

const ACTION_HANDLERS = {
  /**
   * Left bar action handlers.
   */
  [LAYOUT_LEFTBAR_OPEN]: (state, action) => ({
    ...state,
    leftBar: action.bar,
    leftBarModule: null,
    leftBarModuleExtra: null,
  }),
  [LAYOUT_LEFTBAR_CLOSE]: state => ({
    ...state,
    leftBar: null,
    leftBarModule: null,
    leftBarModuleExtra: null,
  }),
  [LAYOUT_LEFTBAR_MODULE_OPEN]: (state, action) => ({
    ...state,
    leftBar: action.bar,
    leftBarModule: action.module,
    leftBarModuleExtra: action.extra,
  }),
  [LAYOUT_LEFTBAR_MODULE_CLOSE]: (state, action) => ({
    ...state,
    leftBar: action.bar,
    leftBarModule: null,
    leftBarModuleExtra: null,
  }),

  /**
   * Inbox action handlers.
   */
  [LAYOUT_INBOX_OPEN]: state => ({ ...state, inboxOpen: true }),
  [LAYOUT_INBOX_CLOSE]: state => ({ ...state, inboxOpen: false }),

  /**
   * Chat drawer action handlers.
   */
  [LAYOUT_CHATDRAWER_OPEN]: state => ({ ...state, chatDrawerOpen: true }),
  [LAYOUT_CHATDRAWER_CLOSE]: state => ({ ...state, chatDrawerOpen: false }),

  /**
   * Snackbar action handlers.
   */
  [LAYOUT_SNACKBAR_MESSAGE_SHOW]: (state, action) => ({ ...state, snackbarMessage: action.payload }),
  [LAYOUT_SNACKBAR_MESSAGE_HIDE]: state => ({ ...state, snackbarMessage: null }),
};


const initialState = {
  leftBar: null,
  leftBarModule: null,
  leftBarExtra: null,
  inboxOpen: false,
  chatDrawerOpen: false,
  snackbarMessage: null
};

const layoutReducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
};

export default layoutReducer;
